
      <div class="paybee-modal-header p-4" id="bulkCheckoutHeader" style="border-bottom:1px solid #D9D9D9">
          <div class="row">
              <div class="col-11">
                  <div class="modal-main-heading">Bulk Checkout</div>
              </div>
              <div class="col-1">
                  <button type="button" class="close cursor--pointer" (click)="close()">
                      <span aria-hidden="true" class="black-text" style="font-size: 30px;font-weight:300">×</span>
                  </button>
              </div>
          </div>
          <div class="row">
              <div class="col">
                  <div class="modal-sub-heading">{{modalSubHeader}}</div>
              </div>
          </div>
      </div>
      <div class="modal-body custom-material-form p-0 pt-3 px-4">
        @switch(activeScreen) {
          @case('selectCheckoutType') {
            <div class="body-1 text-center pb-3">Would you like to check out only auction items in donors' carts?</div>
            <div class="body-2 text-center pb-3">If you select No, auction items and all other pending items in donors' carts will be checked out.</div>
          }
          @case('list') {
            <div *ngIf="userWithSavedCart.length  == 0" style="height: 100px;">
              <span class="body-1">No matching results</span>
            </div>
      
            <div *ngIf="userWithSavedCart.length  !== 0">
              <div class="items-title justify-content-between mb-3 px-2" style="height: 50px;">
                <button class="btn btn--paybee modal-outline-button btn--sm text-center mr-3 p-0" [ngClass]="filteredDonors.length  == 0 ? 'disabled':'' " style="height: 32px;" *ngIf="!isAllSelected" (click)="selectAll()">Select All</button>
                <button class="btn btn--paybee modal-outline-button btn--sm text-center mr-3 p-0" [ngClass]="filteredDonors.length  == 0 ? 'disabled':'' " style="height: 32px;" *ngIf="isAllSelected" (click)="unSelectAll()">Unselect All</button>
                <div class="card__right-side d-flex justify-content-end search">
                  <div class="search__icon-wrapper">
                    <i class="fas fa-search  input-prefix"></i>
                  </div>
                  <input [formControl]="search" class="form-control--search" placeholder="Search..." />
                  <div class="search__icon-wrapper--cross px-1"><span class="cursor-pointer" *ngIf="search.value.length > 0" (click)="resetSearch()">X</span></div>
                </div>
              </div>
              <div style="max-height: 400px; overflow: auto; position: relative;">
      
                <div *ngIf="filteredDonors.length  !== 0">
                  <table class="bulk-checkout-table">
                    <thead>
                      <tr>
                        <th class="body-3"style="max-width: 270px;">Name</th>
                        <th class="body-3">Payment Info</th>
                        <th class="body-3">Amount</th>
                        <th class="body-3">Memo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let option of filteredDonors | paginate : { itemsPerPage: 7, currentPage: p }; let idx = index">
                        <tr [ngClass]="option.checked ? 'checked': '' ">
                            <td class="d-flex align-items-center pl-2" >
                              <div class="form-checkbox checkbox-bulk">
                                <label class="option-item-checkbox mb-0" for="option-{{ option.id }}">
                                  <input
                                    id="option-{{ option.id }}"
                                    mdbCheckbox
                                    class="form-check-input form-checkbox-input"
                                    type="checkbox"
                                    [checked]="option.checked"
                                    (change)="onChange($event, option.id)"
                                  />
                                </label>
                              </div>
                                <div class="d-flex flex-column ml-3">
                                  <span [innerHTML]="option.donorInfo.name" class="subtitle-2"></span>
                                  <span [innerHTML]="option.donorInfo.email" class="body-2"></span>
                                </div>
                            </td>
                            
                            <td [innerHTML]="getCartInfo(option.preSwipreFundingSource)">          
                            </td>
                            <td class="pr-2">
                              <span [innerHTML]="getPaymentStr(option.donationCart)" class="body-2"></span>
                            </td>
                            <td class="text-truncate" style="min-width: 250px;max-width: 250px;">

                              @if(option.donationCart.memo && option.donationCart.memo !== ''){
                                <div class="d-flex align-items-center" style="max-width: 100%;">
                                  <span class="text-truncate text-nowrap mr-2">
                                    {{ option.donationCart.memo }}
                                  </span>
                                  <i (click)="onEditMemo(option)" class="black-text fas fa-pencil-alt mt-0 mr-2" style="cursor: pointer;">
                                  </i>
                                </div>
                              }@else{
                                <a (click)="onEditMemo(option)" class="blue-text small body-2" style="white-space: nowrap;">
                                  <i class="fas fa-plus mr-1"></i>
                                  Add Memo
                                </a>
                              }
                            </td>
                        </tr>
                      </ng-container>
                    </tbody>
        
                  </table>
                </div>
      
                <div *ngIf="filteredDonors.length  == 0" style="min-height: 100px;" class="text-center">
                  <span class="body-1">No matching results</span>
                </div>
      
              </div>
              <div class="items-bottom justify-content-between" *ngIf="filteredDonors.length >= 7 && filteredDonors.length  !== 0">
                <pagination-controls class="mt-4 mr-4 option-pagination" *ngIf="filteredDonors.length >= 7" (pageChange)="p = $event"></pagination-controls>
              </div>
            </div>
          }
          @case('selectedList') {
            <div *ngIf="status == 'checkout'" class="sendAknowledgmentBlock">
              <div class="d-flex justify-content-between align-items-center">
                <span class="subtitle-1 mb-2">Send Donation Acknowledgements</span>
                <div class="form-check form-switch">
                  <label class="form-check-label form-check-label--paybee" for="sendAknowledgment">
                    <input
                      id="sendAknowledgment"
                      mdbCheckbox
                      class="form-check-input form-check-input-bulk form-check-input--paybee"
                      type="checkbox"
                      [checked]="bulkCheckoutService.sendAknowledgment"
                      (change)="bulkCheckoutService.sendAknowledgment = !bulkCheckoutService.sendAknowledgment"
                    />
                  </label>
                </div>
              </div>
              <span class="body-2" style="color: #506556;">If enabled, below donors will receive payment acknowledgments.</span>
            </div>
            <div style="max-height: 400px; overflow: auto; position: relative; border-bottom: 1px solid #D9D9D9;">
              <div class="subtitle-1 mt-3 mb-3" *ngIf="status !== 'checkout'">Please wait, the checkout process takes a few minutes....</div>
              <div class="subtitle-1 mt-3 mb-3" *ngIf="status !== 'checkout'" >Estimated Time: {{bulkCheckoutService.getEstimatedTime()}}</div>
              <table class="bulk-checkout-table">
                <thead>
                  <tr>
                    <th class="body-3" style="max-width: 260px;">Donor</th>
                    <th class="body-3">Amount</th>
                    <th class="body-3" style="min-width: 51px;">Fee Covered</th>
                    <th class="body-3"style="min-width: 70px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let option of bulkCheckoutService.selectedDonors; let idx = index; let last = last">
                    <tr [id]="option.last ? 'lastItem' : null">                
                        <td class="d-flex align-items-center pl-2" >
                            <div [innerHTML]="option.checkoutStatusIcon ? option.checkoutStatusIcon : idx + 1" [ngStyle]="{color:option.checkoutStatusIcon?'':'#25C157'}"
                            
                            class="checkoutStatusIcon mx-3 headline-6"></div>
                            <div class="d-flex flex-column">
                              <span [innerHTML]="option.donorInfo.name" class="subtitle-2"></span>
                              <span [innerHTML]="option.donorInfo.email" class="body-2"></span>
                            </div>
                        </td>
                        <td class="pr-2">
                          <span [innerHTML]="getPaymentStr(option.donationCart)" class="body-2"></span>
                        </td>
                        <td class="position-relative">
                          <div class="form-check form-switch">
                            <label [ngClass]="status !== 'checkout'?'disabled':' ' " class="form-check-label form-check-label--paybee" for="option-{{ option.id }}">
                              <input
                                id="option-{{ option.id }}"
                                mdbCheckbox
                                class="form-check-input form-check-input-bulk form-check-input--paybee"
                                type="checkbox"
                                [checked]="getFeesPaidByDonor(option)"
                                (change)="onGetFeesChange($event, option.id)"
                                [disabled]="status !== 'checkout'"
                              />
                            </label>
                          </div>
                          </td>
                        <td  class="position-relative">
                          <div class="d-flex flex-column">
                            <div [innerHTML]="option.checkoutStatus"></div>
                            <span [innerHTML]="option.errorMessage" class="body-1"></span>
                          </div>
                        </td>
                        
                    </tr>
                  </ng-container>
                </tbody>
      
              </table>
            </div>
          }
          @case('result') {
            <div class="d-flex justify-content-center align-items-center flex-column" style="height: 300px;">
              <div class="resultIcon mb-2" [innerHTML]="finalIcon"></div>
              <span class="headline-6 mb-1">Checkout Completed</span>
              <span class="body-1 mb-4"><span [innerHTML]="getTotalDonated()"></span> total donated</span>
              <span class="body-1"><span class="green-text font-weight-bold">{{resolvedArr.length}}</span> Cart(s) Successfully Processed.</span>
              <span class="body-1"><span class="red-text font-weight-bold">{{rejectedArr.length}}</span> Payment(s) Failed.</span>
            </div>
            <div *ngIf='rejectedArr.length > 0' style="max-height: 200px; overflow: auto; position: relative;">
                <table class="bulk-checkout-table">
                  <thead>
                    <tr>
                      <th class="body-3" style="max-width: 260px;">Donor</th>
                      <th class="body-3">Amount</th>
                      <th class="body-3"style="min-width: 70px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let option of rejectedArr, let idx = index">
                      <tr>                
                        <td class="d-flex align-items-center pl-2" >
                            <div [innerHTML]="option.checkoutStatusIcon"                    
                            class="checkoutStatusIcon mx-3 headline-6"></div>
                            <div class="d-flex flex-column">
                              <span [innerHTML]="option.donorInfo.name" class="subtitle-2"></span>
                              <span [innerHTML]="option.donorInfo.email" class="body-2"></span>
                            </div>
                        </td>
                        <td class="pr-2">
                          <span [innerHTML]="getPaymentStr(option.donationCart)" class="body-2"></span>
                        </td>
                        <td class="position-relative">
                          <div class="d-flex flex-column">
                            <div [innerHTML]="option.checkoutStatus" ></div>
                            <span [innerHTML]="option.errorMessage" class="body-1"></span>
                            <a class="body-2 blue-text" (click)="onTryAgain(option)">Try again</a>
                          </div>
                        </td>                 
                    </tr>
                    </ng-container>
                  </tbody>
                </table>
            </div>
          }
          @case('edit-memo') {
            <div class="custom-material-form">
              <div class="row justify-content-center">
                <div class="col-10">
                  <mdb-form-control class="form-fill form-outline w-100" [formGroup]="editMemoForm">
                    <app-mdbp-input
                      #editMemoInput 
                      mdbInput
                      formControlName="memo"
                      label='Memo (optional)'
                      maxLength="128"  
                      [showMaxLength]="true"
                      ></app-mdbp-input>
                  </mdb-form-control> 
                </div>
              </div>
            </div>
          }
        }
      </div>

      @switch(activeScreen){
        @case('selectCheckoutType') {
          <div class="modal-footer paybee-modal-footer d-flex justify-content-end">
            <button type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light mr-2" (click)="onSelectCheckoutType(false)">No</button>
            <button type="button" class="btn btn-sm modal-confirm-button waves-effect waves-light" (click)="onSelectCheckoutType(true)">Yes</button>
          </div>
        }
        @case ("list"){
          <div class="modal-footer paybee-modal-footer d-flex mt-3" style="position: relative;">
            <div [ngClass]="bulkCheckoutService.selectedCount > 0? 'selected' : '' " class="selected-donors-count">
              <span *ngIf="userWithSavedCart.length  !== 0" class="body-2" ><b>{{bulkCheckoutService.selectedCount}}</b> of <b>{{userWithSavedCart.length}}</b> donors selected</span>
            </div>
            <button class="btn btn-sm modal-success-button waves-effect waves-light" [ngClass]="userWithSavedCart.length  !== 0 ? 'modal-success-button' : 'modal-disabled-button-two'" (click)="onSelectClick()" [disabled]="bulkCheckoutService.selectedCount == 0">Continue</button>
          </div>
        }
        @case ("selectedList"){
          <div class="modal-footer paybee-modal-footer mt-3">
            <div class="d-flex w-100 justify-content-end">
                <button type="button" [disabled]="status !== 'checkout'" class="btn modal-outline-button btn-sm mr-2" (click)="onBackClick()">Back</button>
                <button *ngIf="status == 'checkout'" type="button" class="btn btn-sm modal-success-button waves-effect waves-light" (click)="onStartCheckout()">Checkout</button>
                <button *ngIf="status =='in-progress'" 
                  [ngClass]="isStopHovered?'modal-danger-button':'modal-stop-button' " 
                  (mouseenter)="isStopHovered = true" 
                  (mouseleave)="isStopHovered = false" 
                  type="button" 
                  class="btn btn-sm waves-effect waves-light" 
                  (click)="onStopCheckout()">
                    <span *ngIf="!isStopHovered">Processing {{bulkCheckoutService.finished}} of {{bulkCheckoutService.selectedCount}} Donors…</span>
                    <span *ngIf="isStopHovered">Stop processing</span>
                </button>
                <button *ngIf="status =='stopped'" type="button" class="btn btn-sm modal-success-button waves-effect waves-light" (click)="onContinue()">Continue Checkout</button>
            </div>
          </div>
        }
        @case("result"){
          <div [ngClass]="rejectedArr.length == 0 ? 'mt-5': '' " class="modal-footer paybee-modal-footer d-flex justify-content-end">
            <button type="button" class="btn btn-sm modal-success-button waves-effect waves-light" (click)="close(true)">Done</button>
          </div>
        }
        @case("edit-memo"){
          <div class="modal-footer paybee-modal-footer d-flex justify-content-end">
            <button type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light mr-2" (click)="closeMemoScreen()">Cancel</button>
            <button type="button" class="btn btn-sm modal-confirm-button waves-effect waves-light" (click)="saveEditedMemo()">Save</button>
          </div>
        }
      }